var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "edit-item-background" }, [
    _c(
      "div",
      { staticClass: "edit-item" },
      [
        _c("flex-row", [
          _c(
            "div",
            { staticClass: "col" },
            [
              _c("items-typeahead", {
                attrs: {
                  id: "edit_item_sku",
                  name: "edit_item_sku",
                  placeholder: "",
                  spacing: "xs",
                  value: _vm.item.sku,
                  label: _vm.$t("consumerOrders.labels.sku"),
                  "preloaded-options": _vm.items,
                  "allow-empty": false,
                  "use-templates": true,
                  rules: { required: false },
                  validation: { name: _vm.$t("consumerOrders.labels.sku") },
                  disabled: _vm.isSkuEditDisabled
                },
                on: {
                  input: function(value) {
                    _vm.item.sku = value.sku
                    _vm.item.hsCodeId = value.hsCodeId
                    _vm.item.description = value.description
                    _vm.item.availableQty = value.totalAvailableInventory
                    _vm.item.selectedFromList = true
                    _vm.item.isSerialTracked = value.isSerialTracked
                    _vm.item.availableInventories = value.availableInventories
                    _vm.item.isRecordSerialNumber = value.isSerialTracked
                    _vm.item.isLotTracked = value.isLotTracked
                    _vm.item.hazmatType = value.hazmatType
                  },
                  "skus-loaded": function(loadedOptions) {
                    return _vm.saveSearchResult(loadedOptions)
                  }
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col col--width-qty" },
            [
              _c("form-input", {
                attrs: {
                  id: "edit_item_qty",
                  name: "edit_item_qty",
                  label: _vm.$t("consumerOrders.labels.quantity"),
                  spacing: "xs",
                  type: "number",
                  step: "1",
                  min: "1",
                  rules:
                    "required|min_value:1|max_value:" +
                    _vm.getAvailableCount() +
                    "|max:9",
                  validation: { name: _vm.$t("consumerOrders.labels.quantity") }
                },
                model: {
                  value: _vm.item.quantity,
                  callback: function($$v) {
                    _vm.$set(_vm.item, "quantity", $$v)
                  },
                  expression: "item.quantity"
                }
              })
            ],
            1
          )
        ]),
        _c("flex-row", { staticClass: "selected-item-info" }, [
          _c("div", { staticClass: "item-info-section col" }, [
            _c("label", { staticClass: "info-section-label" }, [
              _vm._v(
                "\n                    " +
                  _vm._s(_vm.$t("consumerOrders.labels.skuDescription")) +
                  "\n                "
              )
            ]),
            _vm.isLotTrackDetail
              ? _c("div", { staticClass: "info-section-disabled-text" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.item.description) +
                      "\n                "
                  )
                ])
              : _c("div", { staticClass: "info-section-text" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.item.description) +
                      "\n                "
                  )
                ])
          ]),
          !_vm.hideAvailableQty
            ? _c(
                "div",
                { staticClass: "item-info-section col col--width-qty" },
                [
                  _c("label", { staticClass: "info-section-label" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("consumerOrders.labels.availableQty")) +
                        "\n                "
                    )
                  ]),
                  _c("div", { staticClass: "info-section-disabled-text" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm._f("valueOrDash")(_vm.getAvailableCount())) +
                        "\n                "
                    )
                  ])
                ]
              )
            : _vm._e(),
          _vm.isLotTrackDetail
            ? _c("div", { staticClass: "item-info-section col" }, [
                _c("label", { staticClass: "info-section-label" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("consumerOrders.labels.lotNumber")) +
                      "\n                "
                  )
                ]),
                _c("div", { staticClass: "info-section-disabled-text" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm._f("valueOrDash")(_vm.item.lotNumber)) +
                      "\n                "
                  )
                ])
              ])
            : _vm._e(),
          _vm.isLotTrackDetail
            ? _c("div", { staticClass: "item-info-section col" }, [
                _c("label", { staticClass: "info-section-label" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("consumerOrders.labels.expiration")) +
                      "\n                "
                  )
                ]),
                _c("div", { staticClass: "info-section-disabled-text" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(
                        _vm._f("valueOrDash")(
                          _vm._f("date")(_vm.item.expirationDate, "short")
                        )
                      ) +
                      "\n                "
                  )
                ])
              ])
            : _vm._e()
        ]),
        _c("flex-row", { staticClass: "selected-item-info" }, [
          _vm.isVisibleRecordSerialNumber && _vm.item.isSerialTracked
            ? _c(
                "div",
                { staticClass: "item-info-section col" },
                [
                  _c("base-radio-check", {
                    attrs: {
                      id: "is-record-serial-number",
                      value: _vm.item.isRecordSerialNumber,
                      type: "checkbox",
                      label: _vm.$t("items.labels.requiredSerialNumberCapture"),
                      "tooltip-text": _vm.$t(
                        "items.labels.requiredSerialNumberCaptureToolTip"
                      )
                    },
                    on: { input: _vm.onRecordSerialNumber }
                  })
                ],
                1
              )
            : _vm._e()
        ]),
        _c("flex-row", { staticClass: "selected-item-info" }, [
          _c(
            "div",
            { staticClass: "item-info-section col" },
            [
              _c(
                "base-button",
                {
                  attrs: {
                    id: "editItem",
                    primary: true,
                    disabled:
                      !_vm.item.sku ||
                      _vm.item.quantity == null ||
                      _vm.item.quantity < 1 ||
                      _vm.item.quantity > _vm.getAvailableCount()
                  },
                  on: { click: _vm.saveItem }
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("consumerOrders.labels.saveSku")) +
                      "\n                "
                  )
                ]
              ),
              _c(
                "base-button",
                {
                  staticClass: "cancel-edit",
                  attrs: { id: "cancelEdit", primary: true },
                  on: { click: _vm.cancel }
                },
                [_vm._v("\n                    Cancel\n                ")]
              )
            ],
            1
          )
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }